import React, { forwardRef } from 'react'

import { Label, LabelProps } from '@rebass/forms'
import { useSTheme } from 'styles/theme'

type Props = LabelProps

const SRadioLabel = forwardRef<any, Props>((props: Props, ref) => {
    const { sx, ...otherProps } = props
    const theme = useSTheme()

    return (
        <Label
            ref={ref}
            sx={{
                width: 'auto',
                fontWeight: '400',
                alignItems: 'center',
                marginBottom: '3px',
                textAlignLast: 'left',
                whiteSpace: 'pre-line',
                lineHeight: '140%',
                fontSize: '14px',
                color: theme.colors.gray400,
                ...sx,
            }}
            {...otherProps}
        />
    )
})

SRadioLabel.displayName = 'SRadioLabel'

export default SRadioLabel
